import { DetailPageTopBarLeftElement } from "./TopBar.styles";
import { memo } from "react";

/**
 * DetailPageTopBarLeft
 *
 * Wraps the left‑aligned content inside a detail‑page top bar using
 * `DetailPageTopBarLeftElement`, memoised to avoid redundant re‑renders.
 *
 * Props
 * - children (React.ReactNode): elements to display inside the left section
 * - …rest (HTMLAttributes<HTMLDivElement>): additional props applied to the container
 */

const DetailPageTopBarLeft = memo(({ children, ...rest }) => {
  return <DetailPageTopBarLeftElement {...rest}>{children}</DetailPageTopBarLeftElement>;
});

export { DetailPageTopBarLeft };
